
<h2 class="mt-4">{{cardConfiguration.title}}</h2>

<div *ngIf="isVersion2()">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="country" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberContacts.Country' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.countryCode" name="country" #country="ngModel" required
                [clearRelated]="{model : this.cardData , propsToReset : ['postalCodeFirst','postalCodeLast','postalCodeFull','postalDesignation','landlineNumber']} " [disabled]="certifiedData?.identificationData?.idenCertification === 'S'"
                [dropdownTitle]="{value : cardData.countryCode, dimensions :  countries }"
                (ngModelChange)="countryChanged()"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of countries" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="country"></validation-message>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="form-group">
        <label for="address" name="address" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberContacts.Address' | translate}}</label>
        <input id="address" class="form-control" type="text" [(ngModel)]="cardData.address" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" name="address" #address="ngModel" maxlength="80" required style='text-transform:uppercase' (change)="capitalize('address')">
        <validation-message [control]="address"></validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <!--Postal Code might change based on format of data received-->
    <div class="col-sm-4" *ngIf="cardData.countryCode=='PT'">
      <div class="form-group">
        <label for="Postal Code" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberContacts.PostalCode' | translate}}</label>
        <div class="form-row">
          <div class="col-sm-6">
            <input class="form-control" type="text" numeric="4" placeholder="{{'Placeholders.Generic.PostalCodeFirst4' | translate}}" [(ngModel)]="cardData.postalCodeFirst" name="postalCodeFirst"
                   #postalCodeFirst="ngModel" exactLength="4" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" required
                   (ngModelChange)="onPostalCodeChanged()">
            <validation-message [control]="postalCodeFirst"></validation-message>
          </div>
          <div class="col-sm-6">
            <input class="form-control" type="text" numeric="3" placeholder="{{'Placeholders.Generic.PostalCodeLast3' | translate}}" [(ngModel)]="cardData.postalCodeLast" name="postalCodeLast"
                   #postalCodeLast="ngModel" exactLength="3" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" pattern="\d*" required
                   (ngModelChange)="onPostalCodeChanged()">
            <validation-message [control]="postalCodeLast"></validation-message>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4" *ngIf="cardData.countryCode!='PT'">
      <div class="form-group">
        <label for="Postal Code" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberContacts.PostalCode' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.Generic.ForeignPostalCode' | translate}}"
               [(ngModel)]="cardData.postalCodeFull" name="postalCodeFull" #postalCodeFull="ngModel" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" required maxlength="20">
        <validation-message [control]="postalCodeFull"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="Postal Designation" class="disabled">{{'CardSubscriberContacts.PostalDesignation' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.CardSubscriberContacts.PostalDesignation' | translate}}" [(ngModel)]="cardData.postalDesignation" name="postalDesignation" #postalDesignation="ngModel" disabled>
        <validation-message [control]="postalDesignation"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="City"><span class="mandatory">*</span>{{'CardSubscriberContacts.City' | translate}}</label>
        <input class="form-control" type="text" [(ngModel)]="cardData.city" name="city" #city="ngModel" maxlength="60" required style='text-transform:uppercase' (change)="capitalize('city')">
        <validation-message [control]="city"></validation-message>
      </div>

    </div>
  </div>

  <!--Postal Code might change based on format of data received-->
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="LandlineNumber">{{'CardSubscriberContacts.LandlineNumber' | translate}}</label>
        <input class="form-control"
               type="text"
               [(ngModel)]="cardData.landlineNumber"
               name="landlineNumber"
               #landlineNumber="ngModel"
               [pattern]="landlinePattern" />
        <validation-message [control]="landlineNumber"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group" [ngClass]="(cardData.prefillTlm?.toString() === 'true' || cgaSiteUser === true) ? 'disabled' : ''">
        <label for="MobileNumber">
          <span class="mandatory">*</span>{{'CardSubscriberContacts.MobileNumber' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberContacts.MobileNumber' | translate}}"></span>
        </label>
        <input class="form-control"
               type="text"
               [(ngModel)]="cardData.mobileNumber"
               name="mobileNumber"
               #mobileNumber="ngModel"
               required
               [disabled]="cardData.prefillTlm?.toString() === 'true' || cgaSiteUser === true"
               [pattern]="mobilePattern"/>
        <validation-message [control]="mobileNumber"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group" [ngClass]="(cardData.prefillEmail?.toString() === 'true' || cgaSiteUser === true) ? 'disabled' : ''">
        <label for="Email">
          <span class="mandatory">*</span><i>{{'CardSubscriberContacts.Email' | translate}}</i>
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardSubscriberContacts.Email' | translate}}"></button>
        </label>

        <input class="form-control" type="email" placeholder="{{'Placeholders.Generic.Email' | translate}}" [(ngModel)]="cardData.email" name="email" #email="ngModel" required maxlength="60" email pattern="^.+@.+\..+$" [disabled]="cardData.prefillEmail?.toString() === 'true' || cgaSiteUser === true">
        <validation-message [control]="email"></validation-message>
      </div>

    </div>
  </div>

  <div class="form-group text-secondary ft-sz-12" style="margin-top: 24px;">
    <label style="display:block">
      O e-mail e o telemóvel são pré-preenchidos com a informação registada na CGA Directa. Caso não estejam atualizados, altere-os na CGA Directa, no menu Ficha utilizador.
      <br />
      <br />
      Os contactos registados na CGA Directa são usados pela CGA para comunicações posteriores.
    </label>
  </div>
</div>

<div *ngIf="!isVersion2()">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="country"><span class="mandatory">*</span>{{'CardSubscriberContacts.Country' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.countryCode" name="country" #country="ngModel" required
                [clearRelated]="{model : this.cardData , propsToReset : ['postalCodeFirst','postalCodeLast','postalCodeFull','postalDesignation','mobileNumber','landlineNumber']} "
                [dropdownTitle]="{value : cardData.countryCode, dimensions :  countries }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of countries" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="country"></validation-message>
      </div>

    </div>
    <div class="col-sm-8">
      <div class="form-group">
        <label for="address"><span class="mandatory">*</span>{{'CardSubscriberContacts.Address' | translate}}</label>
        <input id="address" class="form-control" type="text" placeholder="{{'Placeholders.CardSubscriberContacts.Address' | translate}}" [(ngModel)]="cardData.address" name="address" #address="ngModel" maxlength="60" required>
        <validation-message [control]="address"></validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <!--Postal Code might change based on format of data received-->
    <div class="col-sm-4" *ngIf="cardData.countryCode=='PT'">
      <div class="form-group">
        <label for="Postal Code" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberContacts.PostalCode' | translate}}</label>
        <div class="form-row">
          <div class="col-sm-6">
            <input class="form-control" type="text" numeric="4" placeholder="{{'Placeholders.Generic.PostalCodeFirst4' | translate}}" [(ngModel)]="cardData.postalCodeFirst" name="postalCodeFirst"
                   #postalCodeFirst="ngModel" exactLength="4" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" required
                   (ngModelChange)="onPostalCodeChanged()">
            <validation-message [control]="postalCodeFirst"></validation-message>
          </div>
          <div class="col-sm-6">
            <input class="form-control" type="text" numeric="3" placeholder="{{'Placeholders.Generic.PostalCodeLast3' | translate}}" [(ngModel)]="cardData.postalCodeLast" name="postalCodeLast"
                   #postalCodeLast="ngModel" exactLength="3" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" pattern="\d*" required
                   (ngModelChange)="onPostalCodeChanged()">
            <validation-message [control]="postalCodeLast"></validation-message>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4" *ngIf="cardData.countryCode!='PT'">
      <div class="form-group">
        <label for="Postal Code" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberContacts.PostalCode' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.Generic.ForeignPostalCode' | translate}}"
               [(ngModel)]="cardData.postalCodeFull" name="postalCodeFull" #postalCodeFull="ngModel" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" required maxlength="20">
        <validation-message [control]="postalCodeFull"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="Postal Designation" class="disabled">{{'CardSubscriberContacts.PostalDesignation' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.CardSubscriberContacts.PostalDesignation' | translate}}" [(ngModel)]="cardData.postalDesignation" name="postalDesignation" #postalDesignation="ngModel" disabled>
        <validation-message [control]="postalDesignation"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="City"><span class="mandatory">*</span>{{'CardSubscriberContacts.City' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.CardSubscriberContacts.City' | translate}}" [(ngModel)]="cardData.city" name="city" #city="ngModel" maxlength="60" required>
        <validation-message [control]="city"></validation-message>
      </div>

    </div>
  </div>

  <!--Postal Code might change based on format of data received-->
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="LandlineNumber">{{'CardSubscriberContacts.LandlineNumber' | translate}}</label>
        <input class="form-control"
               type="text"
               [(ngModel)]="cardData.landlineNumber"
               name="landlineNumber"
               #landlineNumber="ngModel"
               [pattern]="landlinePattern" />
        <validation-message [control]="landlineNumber"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group" [ngClass]="cardData.pokrefillTlm?.toString() == 'true' ? 'disabled' : ''">
        <label for="MobileNumber">
          <span class="mandatory">*</span>{{'CardSubscriberContacts.MobileNumber' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberContacts.MobileNumber' | translate}}"></span>
        </label>
        <input class="form-control"
               type="text"
               [(ngModel)]="cardData.mobileNumber"
               name="mobileNumber"
               #mobileNumber="ngModel"
               required
               [disabled]="cardData.prefillTlm?.toString() == 'true'"
               [pattern]="mobilePattern" />
        <validation-message [control]="mobileNumber"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group" [ngClass]="cardData.prefillEmail?.toString() == 'true' ? 'disabled' : ''">
        <label for="Email">
          <span class="mandatory">*</span><i>{{'CardSubscriberContacts.Email' | translate}}</i>
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardSubscriberContacts.Email' | translate}}"></button>
        </label>

        <input class="form-control" type="email" placeholder="{{'Placeholders.Generic.Email' | translate}}" [(ngModel)]="cardData.email" name="email" #email="ngModel" required maxlength="60" email pattern="^.+@.+\..+$" [disabled]="cardData.prefillEmail?.toString()">
        <validation-message [control]="email"></validation-message>
      </div>

    </div>
  </div>
</div>
<!--<pre>{{cardData | json}}</pre> -->
